/* tslint:disable */
/* eslint-disable */
/**
 * sicobMs
 * API para el microservicio sicobMs
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { Configuration } from './configuration';
import globalAxios, { AxiosPromise, AxiosInstance, AxiosRequestConfig } from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from './common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from './base';

/**
 * 
 * @export
 * @interface DatosGenerales
 */
export interface DatosGenerales {
    /**
     * 
     * @type {string}
     * @memberof DatosGenerales
     */
    'numeroCvu'?: string;
    /**
     * 
     * @type {string}
     * @memberof DatosGenerales
     */
    'rfc'?: string;
    /**
     * 
     * @type {string}
     * @memberof DatosGenerales
     */
    'curp'?: string;
    /**
     * 
     * @type {string}
     * @memberof DatosGenerales
     */
    'claveSicob'?: string;
    /**
     * 
     * @type {string}
     * @memberof DatosGenerales
     */
    'nombre'?: string;
    /**
     * 
     * @type {string}
     * @memberof DatosGenerales
     */
    'paterno'?: string;
    /**
     * 
     * @type {string}
     * @memberof DatosGenerales
     */
    'materno'?: string;
    /**
     * 
     * @type {string}
     * @memberof DatosGenerales
     */
    'numeroBeca'?: string;
    /**
     * 
     * @type {string}
     * @memberof DatosGenerales
     */
    'registroBecarioEmplid'?: string;
    /**
     * 
     * @type {string}
     * @memberof DatosGenerales
     */
    'inicioBeca'?: string;
    /**
     * 
     * @type {string}
     * @memberof DatosGenerales
     */
    'terminoBeca'?: string;
    /**
     * 
     * @type {string}
     * @memberof DatosGenerales
     */
    'modalidadBeca'?: string;
    /**
     * 
     * @type {string}
     * @memberof DatosGenerales
     */
    'tipoBeca'?: string;
    /**
     * 
     * @type {string}
     * @memberof DatosGenerales
     */
    'pais'?: string;
    /**
     * 
     * @type {string}
     * @memberof DatosGenerales
     */
    'institucion'?: string;
    /**
     * 
     * @type {string}
     * @memberof DatosGenerales
     */
    'descripcionGrado'?: string;
    /**
     * 
     * @type {string}
     * @memberof DatosGenerales
     */
    'programa'?: string;
    /**
     * 
     * @type {string}
     * @memberof DatosGenerales
     */
    'area'?: string;
    /**
     * 
     * @type {string}
     * @memberof DatosGenerales
     */
    'tipoFinanciamiento'?: string;
    /**
     * 
     * @type {string}
     * @memberof DatosGenerales
     */
    'estatusSeguimiento'?: string;
    /**
     * 
     * @type {string}
     * @memberof DatosGenerales
     */
    'fechaObtGrado'?: string;
    /**
     * 
     * @type {string}
     * @memberof DatosGenerales
     */
    'convocatoria'?: string;
}
/**
 * 
 * @export
 * @interface ListadoApoyos
 */
export interface ListadoApoyos {
    /**
     * 
     * @type {string}
     * @memberof ListadoApoyos
     */
    'cvu'?: string;
    /**
     * 
     * @type {string}
     * @memberof ListadoApoyos
     */
    'rfc'?: string;
    /**
     * 
     * @type {string}
     * @memberof ListadoApoyos
     */
    'curp'?: string;
    /**
     * 
     * @type {string}
     * @memberof ListadoApoyos
     */
    'claveSicob'?: string;
    /**
     * 
     * @type {string}
     * @memberof ListadoApoyos
     */
    'nombre'?: string;
    /**
     * 
     * @type {string}
     * @memberof ListadoApoyos
     */
    'paterno'?: string;
    /**
     * 
     * @type {string}
     * @memberof ListadoApoyos
     */
    'materno'?: string;
    /**
     * 
     * @type {string}
     * @memberof ListadoApoyos
     */
    'numeroBeca'?: string;
    /**
     * 
     * @type {string}
     * @memberof ListadoApoyos
     */
    'registroBecarioEmplid'?: string;
    /**
     * 
     * @type {string}
     * @memberof ListadoApoyos
     */
    'inicioBeca'?: string;
    /**
     * 
     * @type {string}
     * @memberof ListadoApoyos
     */
    'terminoBeca'?: string;
    /**
     * 
     * @type {string}
     * @memberof ListadoApoyos
     */
    'modalidadBeca'?: string;
    /**
     * 
     * @type {string}
     * @memberof ListadoApoyos
     */
    'tipoBeca'?: string;
    /**
     * 
     * @type {string}
     * @memberof ListadoApoyos
     */
    'pais'?: string;
    /**
     * 
     * @type {string}
     * @memberof ListadoApoyos
     */
    'institucion'?: string;
    /**
     * 
     * @type {string}
     * @memberof ListadoApoyos
     */
    'descripcionGrado'?: string;
    /**
     * 
     * @type {string}
     * @memberof ListadoApoyos
     */
    'programa'?: string;
    /**
     * 
     * @type {string}
     * @memberof ListadoApoyos
     */
    'area'?: string;
    /**
     * 
     * @type {string}
     * @memberof ListadoApoyos
     */
    'tipoFinanciamiento'?: string;
    /**
     * 
     * @type {string}
     * @memberof ListadoApoyos
     */
    'estatusSeguimiento'?: string;
    /**
     * 
     * @type {string}
     * @memberof ListadoApoyos
     */
    'fechaObtGrado'?: string;
    /**
     * 
     * @type {string}
     * @memberof ListadoApoyos
     */
    'convocatoria'?: string;
}
/**
 * 
 * @export
 * @interface Problem
 */
export interface Problem {
    /**
     * An absolute URI that identifies the problem type.  When dereferenced, it SHOULD provide human-readable documentation for the problem type (e.g., using HTML). 
     * @type {string}
     * @memberof Problem
     */
    'type'?: string;
    /**
     * A short, summary of the problem type. Written in english and readable for engineers (usually not suited for non technical stakeholders and not localized); example: Service Unavailable 
     * @type {string}
     * @memberof Problem
     */
    'title'?: string;
    /**
     * The HTTP status code generated by the origin server for this occurrence of the problem. 
     * @type {number}
     * @memberof Problem
     */
    'status'?: number;
    /**
     * A human readable explanation specific to this occurrence of the problem. 
     * @type {string}
     * @memberof Problem
     */
    'detail'?: string;
    /**
     * An absolute URI that identifies the specific occurrence of the problem. It may or may not yield further information if dereferenced. 
     * @type {string}
     * @memberof Problem
     */
    'instance'?: string;
}
/**
 * 
 * @export
 * @interface SeguimientoAdministrativo
 */
export interface SeguimientoAdministrativo {
    /**
     * 
     * @type {string}
     * @memberof SeguimientoAdministrativo
     */
    'idCvu'?: string;
    /**
     * 
     * @type {string}
     * @memberof SeguimientoAdministrativo
     */
    'numeroBeca'?: string;
    /**
     * 
     * @type {string}
     * @memberof SeguimientoAdministrativo
     */
    'claveSicob'?: string;
    /**
     * 
     * @type {string}
     * @memberof SeguimientoAdministrativo
     */
    'nombreBecario'?: string;
    /**
     * 
     * @type {string}
     * @memberof SeguimientoAdministrativo
     */
    'rfc'?: string;
    /**
     * 
     * @type {string}
     * @memberof SeguimientoAdministrativo
     */
    'curp'?: string;
    /**
     * 
     * @type {string}
     * @memberof SeguimientoAdministrativo
     */
    'fechaCaptura'?: string;
    /**
     * 
     * @type {string}
     * @memberof SeguimientoAdministrativo
     */
    'fechaAplica'?: string;
    /**
     * 
     * @type {string}
     * @memberof SeguimientoAdministrativo
     */
    'claveMovimiento'?: string;
    /**
     * 
     * @type {string}
     * @memberof SeguimientoAdministrativo
     */
    'movimiento'?: string;
    /**
     * 
     * @type {string}
     * @memberof SeguimientoAdministrativo
     */
    'comentario'?: string;
    /**
     * 
     * @type {string}
     * @memberof SeguimientoAdministrativo
     */
    'usuarioCaptClave'?: string;
    /**
     * 
     * @type {string}
     * @memberof SeguimientoAdministrativo
     */
    'nombreCaptClave'?: string;
    /**
     * 
     * @type {string}
     * @memberof SeguimientoAdministrativo
     */
    'paternoCaptClave'?: string;
    /**
     * 
     * @type {string}
     * @memberof SeguimientoAdministrativo
     */
    'maternoCaptClave'?: string;
    /**
     * 
     * @type {string}
     * @memberof SeguimientoAdministrativo
     */
    'usuarioAutClave'?: string;
    /**
     * 
     * @type {string}
     * @memberof SeguimientoAdministrativo
     */
    'nombreAutClave'?: string;
    /**
     * 
     * @type {string}
     * @memberof SeguimientoAdministrativo
     */
    'paternoAutClave'?: string;
    /**
     * 
     * @type {string}
     * @memberof SeguimientoAdministrativo
     */
    'maternoAutClave'?: string;
}
/**
 * 
 * @export
 * @interface SeguimientoPago
 */
export interface SeguimientoPago {
    /**
     * 
     * @type {string}
     * @memberof SeguimientoPago
     */
    'numeroBeca'?: string;
    /**
     * 
     * @type {string}
     * @memberof SeguimientoPago
     */
    'nomina'?: string;
    /**
     * 
     * @type {string}
     * @memberof SeguimientoPago
     */
    'personaClave'?: string;
    /**
     * 
     * @type {string}
     * @memberof SeguimientoPago
     */
    'manutencion'?: string;
    /**
     * 
     * @type {string}
     * @memberof SeguimientoPago
     */
    'colegiatura'?: string;
    /**
     * 
     * @type {string}
     * @memberof SeguimientoPago
     */
    'seguro'?: string;
    /**
     * 
     * @type {string}
     * @memberof SeguimientoPago
     */
    'reembolso'?: string;
    /**
     * 
     * @type {string}
     * @memberof SeguimientoPago
     */
    'otro'?: string;
    /**
     * 
     * @type {string}
     * @memberof SeguimientoPago
     */
    'pais'?: string;
}

/**
 * DatosGeneralesApi - axios parameter creator
 * @export
 */
export const DatosGeneralesApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Obtiene la información general del Exbecario.
         * @param {string} numeroBeca numeroBeca
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findByNumeroApoyo: async (numeroBeca: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'numeroBeca' is not null or undefined
            assertParamExists('findByNumeroApoyo', 'numeroBeca', numeroBeca)
            const localVarPath = `/datos-generales/{numeroBeca}`
                .replace(`{${"numeroBeca"}}`, encodeURIComponent(String(numeroBeca)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth", ["jhipster", "email", "profile"], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * DatosGeneralesApi - functional programming interface
 * @export
 */
export const DatosGeneralesApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = DatosGeneralesApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Obtiene la información general del Exbecario.
         * @param {string} numeroBeca numeroBeca
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async findByNumeroApoyo(numeroBeca: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DatosGenerales>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.findByNumeroApoyo(numeroBeca, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * DatosGeneralesApi - factory interface
 * @export
 */
export const DatosGeneralesApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = DatosGeneralesApiFp(configuration)
    return {
        /**
         * 
         * @summary Obtiene la información general del Exbecario.
         * @param {string} numeroBeca numeroBeca
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findByNumeroApoyo(numeroBeca: string, options?: any): AxiosPromise<DatosGenerales> {
            return localVarFp.findByNumeroApoyo(numeroBeca, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * DatosGeneralesApi - object-oriented interface
 * @export
 * @class DatosGeneralesApi
 * @extends {BaseAPI}
 */
export class DatosGeneralesApi extends BaseAPI {
    /**
     * 
     * @summary Obtiene la información general del Exbecario.
     * @param {string} numeroBeca numeroBeca
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DatosGeneralesApi
     */
    public findByNumeroApoyo(numeroBeca: string, options?: AxiosRequestConfig) {
        return DatosGeneralesApiFp(this.configuration).findByNumeroApoyo(numeroBeca, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * JobApi - axios parameter creator
 * @export
 */
export const JobApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Recupera el estado del job de jobrunr
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getjobStatus: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getjobStatus', 'id', id)
            const localVarPath = `/sicob-job/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth", ["jhipster", "email", "profile"], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * JobApi - functional programming interface
 * @export
 */
export const JobApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = JobApiAxiosParamCreator(configuration)
    return {
        /**
         * Recupera el estado del job de jobrunr
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getjobStatus(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getjobStatus(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * JobApi - factory interface
 * @export
 */
export const JobApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = JobApiFp(configuration)
    return {
        /**
         * Recupera el estado del job de jobrunr
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getjobStatus(id: string, options?: any): AxiosPromise<string> {
            return localVarFp.getjobStatus(id, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * JobApi - object-oriented interface
 * @export
 * @class JobApi
 * @extends {BaseAPI}
 */
export class JobApi extends BaseAPI {
    /**
     * Recupera el estado del job de jobrunr
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof JobApi
     */
    public getjobStatus(id: string, options?: AxiosRequestConfig) {
        return JobApiFp(this.configuration).getjobStatus(id, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * ListadoApoyosApi - axios parameter creator
 * @export
 */
export const ListadoApoyosApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Obtiene el listado de apoyos que ha tenido un beneficiario en SICOB.
         * @param {string} cvu Número de CVU
         * @param {string} nombre Nombre Ex-Becario
         * @param {string} paterno Apellido Paterno Ex-Becario
         * @param {string} materno Apellido Materni Ex-Becario
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTotalApoyos: async (cvu: string, nombre: string, paterno: string, materno: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'cvu' is not null or undefined
            assertParamExists('getTotalApoyos', 'cvu', cvu)
            // verify required parameter 'nombre' is not null or undefined
            assertParamExists('getTotalApoyos', 'nombre', nombre)
            // verify required parameter 'paterno' is not null or undefined
            assertParamExists('getTotalApoyos', 'paterno', paterno)
            // verify required parameter 'materno' is not null or undefined
            assertParamExists('getTotalApoyos', 'materno', materno)
            const localVarPath = `/listado-apoyos/{cvu}/{nombre}/{paterno}/{materno}`
                .replace(`{${"cvu"}}`, encodeURIComponent(String(cvu)))
                .replace(`{${"nombre"}}`, encodeURIComponent(String(nombre)))
                .replace(`{${"paterno"}}`, encodeURIComponent(String(paterno)))
                .replace(`{${"materno"}}`, encodeURIComponent(String(materno)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth", ["jhipster", "email", "profile"], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ListadoApoyosApi - functional programming interface
 * @export
 */
export const ListadoApoyosApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ListadoApoyosApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Obtiene el listado de apoyos que ha tenido un beneficiario en SICOB.
         * @param {string} cvu Número de CVU
         * @param {string} nombre Nombre Ex-Becario
         * @param {string} paterno Apellido Paterno Ex-Becario
         * @param {string} materno Apellido Materni Ex-Becario
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTotalApoyos(cvu: string, nombre: string, paterno: string, materno: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ListadoApoyos>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getTotalApoyos(cvu, nombre, paterno, materno, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * ListadoApoyosApi - factory interface
 * @export
 */
export const ListadoApoyosApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ListadoApoyosApiFp(configuration)
    return {
        /**
         * 
         * @summary Obtiene el listado de apoyos que ha tenido un beneficiario en SICOB.
         * @param {string} cvu Número de CVU
         * @param {string} nombre Nombre Ex-Becario
         * @param {string} paterno Apellido Paterno Ex-Becario
         * @param {string} materno Apellido Materni Ex-Becario
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTotalApoyos(cvu: string, nombre: string, paterno: string, materno: string, options?: any): AxiosPromise<Array<ListadoApoyos>> {
            return localVarFp.getTotalApoyos(cvu, nombre, paterno, materno, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ListadoApoyosApi - object-oriented interface
 * @export
 * @class ListadoApoyosApi
 * @extends {BaseAPI}
 */
export class ListadoApoyosApi extends BaseAPI {
    /**
     * 
     * @summary Obtiene el listado de apoyos que ha tenido un beneficiario en SICOB.
     * @param {string} cvu Número de CVU
     * @param {string} nombre Nombre Ex-Becario
     * @param {string} paterno Apellido Paterno Ex-Becario
     * @param {string} materno Apellido Materni Ex-Becario
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ListadoApoyosApi
     */
    public getTotalApoyos(cvu: string, nombre: string, paterno: string, materno: string, options?: AxiosRequestConfig) {
        return ListadoApoyosApiFp(this.configuration).getTotalApoyos(cvu, nombre, paterno, materno, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * SeguimientoAdministrativoApi - axios parameter creator
 * @export
 */
export const SeguimientoAdministrativoApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Obtiene el histórico de los movimientos administrativos del becario.
         * @param {string} numeroBeca numeroBeca
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findByIdBeca: async (numeroBeca: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'numeroBeca' is not null or undefined
            assertParamExists('findByIdBeca', 'numeroBeca', numeroBeca)
            const localVarPath = `/seguimiento-administrativo/{numeroBeca}`
                .replace(`{${"numeroBeca"}}`, encodeURIComponent(String(numeroBeca)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth", ["jhipster", "email", "profile"], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * SeguimientoAdministrativoApi - functional programming interface
 * @export
 */
export const SeguimientoAdministrativoApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = SeguimientoAdministrativoApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Obtiene el histórico de los movimientos administrativos del becario.
         * @param {string} numeroBeca numeroBeca
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async findByIdBeca(numeroBeca: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<SeguimientoAdministrativo>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.findByIdBeca(numeroBeca, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * SeguimientoAdministrativoApi - factory interface
 * @export
 */
export const SeguimientoAdministrativoApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = SeguimientoAdministrativoApiFp(configuration)
    return {
        /**
         * 
         * @summary Obtiene el histórico de los movimientos administrativos del becario.
         * @param {string} numeroBeca numeroBeca
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findByIdBeca(numeroBeca: string, options?: any): AxiosPromise<Array<SeguimientoAdministrativo>> {
            return localVarFp.findByIdBeca(numeroBeca, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * SeguimientoAdministrativoApi - object-oriented interface
 * @export
 * @class SeguimientoAdministrativoApi
 * @extends {BaseAPI}
 */
export class SeguimientoAdministrativoApi extends BaseAPI {
    /**
     * 
     * @summary Obtiene el histórico de los movimientos administrativos del becario.
     * @param {string} numeroBeca numeroBeca
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SeguimientoAdministrativoApi
     */
    public findByIdBeca(numeroBeca: string, options?: AxiosRequestConfig) {
        return SeguimientoAdministrativoApiFp(this.configuration).findByIdBeca(numeroBeca, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * SeguimientoPagoApi - axios parameter creator
 * @export
 */
export const SeguimientoPagoApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Obtiene la información de los pagos realizados al becario.
         * @param {string} numeroBeca numeroBeca
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findByNumeroBeca: async (numeroBeca: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'numeroBeca' is not null or undefined
            assertParamExists('findByNumeroBeca', 'numeroBeca', numeroBeca)
            const localVarPath = `/seguimiento-pago/{numeroBeca}`
                .replace(`{${"numeroBeca"}}`, encodeURIComponent(String(numeroBeca)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth", ["jhipster", "email", "profile"], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * SeguimientoPagoApi - functional programming interface
 * @export
 */
export const SeguimientoPagoApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = SeguimientoPagoApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Obtiene la información de los pagos realizados al becario.
         * @param {string} numeroBeca numeroBeca
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async findByNumeroBeca(numeroBeca: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<SeguimientoPago>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.findByNumeroBeca(numeroBeca, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * SeguimientoPagoApi - factory interface
 * @export
 */
export const SeguimientoPagoApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = SeguimientoPagoApiFp(configuration)
    return {
        /**
         * 
         * @summary Obtiene la información de los pagos realizados al becario.
         * @param {string} numeroBeca numeroBeca
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findByNumeroBeca(numeroBeca: string, options?: any): AxiosPromise<Array<SeguimientoPago>> {
            return localVarFp.findByNumeroBeca(numeroBeca, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * SeguimientoPagoApi - object-oriented interface
 * @export
 * @class SeguimientoPagoApi
 * @extends {BaseAPI}
 */
export class SeguimientoPagoApi extends BaseAPI {
    /**
     * 
     * @summary Obtiene la información de los pagos realizados al becario.
     * @param {string} numeroBeca numeroBeca
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SeguimientoPagoApi
     */
    public findByNumeroBeca(numeroBeca: string, options?: AxiosRequestConfig) {
        return SeguimientoPagoApiFp(this.configuration).findByNumeroBeca(numeroBeca, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * SicobApi - axios parameter creator
 * @export
 */
export const SicobApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Recupera el estado del job de jobrunr
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getjobStatus: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getjobStatus', 'id', id)
            const localVarPath = `/sicob-job/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth", ["jhipster", "email", "profile"], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * SicobApi - functional programming interface
 * @export
 */
export const SicobApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = SicobApiAxiosParamCreator(configuration)
    return {
        /**
         * Recupera el estado del job de jobrunr
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getjobStatus(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getjobStatus(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * SicobApi - factory interface
 * @export
 */
export const SicobApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = SicobApiFp(configuration)
    return {
        /**
         * Recupera el estado del job de jobrunr
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getjobStatus(id: string, options?: any): AxiosPromise<string> {
            return localVarFp.getjobStatus(id, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * SicobApi - object-oriented interface
 * @export
 * @class SicobApi
 * @extends {BaseAPI}
 */
export class SicobApi extends BaseAPI {
    /**
     * Recupera el estado del job de jobrunr
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SicobApi
     */
    public getjobStatus(id: string, options?: AxiosRequestConfig) {
        return SicobApiFp(this.configuration).getjobStatus(id, options).then((request) => request(this.axios, this.basePath));
    }
}


